import React, { useEffect, useState, useCallback } from "react";
import styles from "./Feed.module.scss";
import { connect } from "react-redux";
import {
    openFeedTextModal,
    closeMainModal,
    getPosteos,
    getOwnPosteos,
    openWorkOfferModal,
    resetRecentPost,
    openSuscriptionModal
} from "../../../store/actions";
import usePremiumCheck from "../../../hooks/usePremiumCheck";
import FeedCard from "./FeedCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faVideo, faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as Cotizacion } from "../../../assets/svg/marketplaceActive.svg";
import { ReactComponent as ObraPrivada } from "../../../assets/svg/misProyectosLittle.svg";
import { ReactComponent as Proyectos } from "../../../assets/svg/nav-proyectos.svg";
import { HardHat } from "lucide-react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import { useNavigate } from "react-router-dom";
import FeedCardSkeleton from "./FeedCardSkeleton";
import InfiniteScroll from 'react-infinite-scroller';
import { motion } from "framer-motion";
import useUserImage from "../../../hooks/useUserImage";
import CLICK_IDS from "../../../utils/analyticsClickIds";
import { fireAnalytics } from "../../../utils/firebase";


const Feed = ({
    userData,
    openFeedTextModal,
    isUserPremium,
    closeMainModal,
    getPosteos,
    getOwnPosteos,
    ownPosteos,
    resetRecentPost,
    posteos,
    openSuscriptionModal,
    openWorkOfferModal,
    recentPost,
    ...props }) => {
    const [selectedOption, setSelectedOption] = useState("Ordenar");
    const [showMenu, setShowMenu] = useState(false);
    const [myPosts, setMyPosts] = useState(false);
    const [items, setItems] = useState([]);
    const [loadingMore, setLoadingMore] = useState(false);
    const [isSorted, setIsSorted] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [isMyLike, setIsMyLike] = useState(false);
    const [likes, setLikes] = useState([]);

    const { imageError, initials, profileImage } = useUserImage(userData);

    const premiumCheck = usePremiumCheck();
    const navigate = useNavigate();

    //Carga los posteos
    useEffect(() => {
        getPosteos("DESC", "DATE");
        resetRecentPost();
    }, []);

    useEffect(() => {
        if (selectedOption === "recomendados") {
            getPosteos("ASC", "MG");

        } else if (selectedOption === "recientes") {
            getPosteos("DESC", "DATE");
        }

    }, [selectedOption, posteos, likes]);


    //Quita InfiniteScroll si se ordena por recomendados, propios o recientes
    useEffect(() => {
        if (isSorted) {
            setItems(posteos);
            setLoadingMore(false);
        }
    }, [posteos, likes]);

    //Actualiza la lista una vez que el usuario crea un posteo
    useEffect(() => {
        if (recentPost?.user?.id == userData?.id) {
            getPosteos("DESC", "DATE");
            setSelectedOption("recientes");
            setIsSorted(true);
        }
    }, [recentPost]);

    const handleNewOpenProject = () => {
        if (isUserPremium) {
            fireAnalytics("crear_obra_privada", { obra_privada_user_id: userData.id });
            navigate("/obrasprivadas/crear");
        } else {
            fireAnalytics("usuario_sin_plan", { no_plan_user_info: userData.id});
            openSuscriptionModal();
        }
    };

    const sizes = [
        { columns: 1, gutter: 10 },
        { mq: '768px', columns: 2, gutter: 10 },
        { mq: '1024px', columns: 3, gutter: 10 }
    ];

    const shufflePost = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    };

    const fetchItems = useCallback(async () => {
        let isMounted = true;

        if (loadingMore || !isMounted) {
            return;
        }

        setLoadingMore(true);

        try {
            const newItems = myPosts ? ownPosteos : posteos;

            const shuffledItems = !isSorted ? shufflePost(newItems) : newItems;

            if (!isMounted) {
                return;
            }

            setItems((prevItems) => (page === 1 ? shuffledItems : [...prevItems, ...shuffledItems]));

            await new Promise((resolve) => setTimeout(resolve, 3000));

            if (!isMounted) {
                return;
            }

            if (newItems.length === 0) {
                setHasMore(false);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            if (isMounted) {
                setLoadingMore(false);
                setPage((prevPage) => prevPage + 1);
            }
        }
    }, [page, myPosts, ownPosteos, posteos, loadingMore]);

    //Abre el modal de texto
    const handleOpenMainModalTxt = () => {
        openFeedTextModal({
            text: true,
        });
    };

    //Abre el modal de imagen
    const handleOpenMainModalWithImg = () => {
        openFeedTextModal({
            image: true,
        });
    }

    //Abre el modal de video
    const handleOpenMainModalWithVideo = () => {
        openFeedTextModal({
            video: true,
        });
    };

    //Menu de opciones de visualizacion
    const handleOptionClick = (option) => {
        setSelectedOption(option);

        if (option === "recientes") {
            setMyPosts(false);
            setIsSorted(true)
        }
        if (option === "recomendados") {
            setMyPosts(false);
            setLoadingMore(true);
            setIsSorted(true);

        }
        if (option === "propios") {
            getOwnPosteos(userData.id);
            setMyPosts(true);
            setIsSorted(false);
            setItems(ownPosteos);
        }
        setShowMenu(false);
    };

    const getButtonLabel = (option) => {
        switch (option) {
            case "recientes":
                return "Recientes";
            case "propios":
                return "Propios";
            case "recomendados":
                return "Recomendados";
            default:
                return "Aleatorio";
        }
    };
    const handleLikeFromChild = (postId) => {
        setIsMyLike(!isMyLike);
    };

    const handleRedirectToQuotation = () => {
        if (isUserPremium) {
            navigate("/cotizaciondemateriales/crear");
        } else {
            fireAnalytics("usuario_sin_plan", { no_plan_user_info: userData.id});
            openSuscriptionModal();
        }
    };

    const handleCreateWorkOffer = () => {
        if (isUserPremium) {
            openWorkOfferModal();
        } else {
            fireAnalytics("usuario_sin_plan", { no_plan_user_info: userData.id});
            openSuscriptionModal();
        }
    }


    return (
        <div className={styles.container}>
            <div className={styles.feed}>
                <div className={styles.feed_header}>
                    <div className={styles.feed_itemHeader}>
                        <div className={styles.feed_itemHeaderAvatar}>
                            {!imageError && profileImage ? (
                                <img
                                    className={styles.feed_itemHeaderAvatar_img}
                                    src={profileImage}
                                    alt="user"
                                />
                            ) : (
                                <div className={styles.feed_itemHeaderAvatar_initials}>{initials}</div>
                            )}
                        </div>
                        <div className={styles.feed_input} onClick={premiumCheck(handleOpenMainModalTxt)}>
                            <input type="text"
                                readOnly
                                placeholder={"¿Qué querés publicar en el muro de edify?"}
                                className={styles.feed_input_item} />

                        </div>
                        <div className={styles.feed_itemFooterContainer} >
                            <div className={styles.feed_itemFooterContainer_buttons}>
                                <div className={styles.feed_itemFooterLeft} onClick={premiumCheck(handleOpenMainModalWithImg)}>
                                    <FontAwesomeIcon icon={faCamera} style={{ fontSize: '2.5rem' }} />
                                </div>
                                <div className={styles.feed_itemFooterRight} onClick={premiumCheck(handleOpenMainModalWithVideo)}>
                                    <FontAwesomeIcon icon={faVideo} style={{ fontSize: '2.5rem' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.feed_buttonsContainer} >
                <h2 className={styles.feed_buttonsContainer_title}>¿Qué necesitás hacer?</h2>
                <h5 className={styles.feed_buttonsContainer_subtitle}>Selecciona una opción para comenzar</h5>
                <div className={styles.feed_buttonsContainer_buttons}>
                    <div
                        id={CLICK_IDS.OBRA_PRIVADA_BUTTON_HOME}
                        className={`${styles.feed_buttonsContainer_button} 
                        ${styles.hoverObraPrivada} 
                        ${styles.feed_buttonsContainer_button_obraPrivada}`}
                        onClick={handleNewOpenProject}
                    >
                        <div className={styles.feed_buttonsContainer_button_text_title}
                            style={{ color: "#234ba2" }} >
                            <div className={`${styles.feed_buttonsContainer_button_icon} ${styles.feed_buttonsContainer_button_icon_obraPrivada} `}>
                                <ObraPrivada width={22} height={22} />
                            </div>
                            Obra privada
                        </div>
                        <div className={styles.feed_buttonsContainer_button_text}>
                            <span>Publica tu proyecto y recibe propuestas de profesionales calificados</span>
                        </div>
                    </div>
                    <div
                        id={CLICK_IDS.COTIZACION_MATERIALES_BUTTON_HOME}
                        className={`${styles.feed_buttonsContainer_button} ${styles.hoverCotizacion} ${styles.feed_buttonsContainer_button_cotizacion}`}
                        onClick={handleRedirectToQuotation}
                    >
                        <div className={styles.feed_buttonsContainer_button_text_title} style={{ color: "#45A7FF" }}>
                            <div className={`${styles.feed_buttonsContainer_button_icon} ${styles.feed_buttonsContainer_button_icon_cotizacion}`}>
                                <Cotizacion width={22} height={22} />
                            </div>
                            Cotización de materiales
                        </div>
                        <div className={styles.feed_buttonsContainer_button_text}>
                            <span>Crea una lista y recibe cotizaciones de proveedores de materiales</span>
                        </div>
                    </div>
                    <div
                        id={CLICK_IDS.MURO_BUTTON_HOME}
                        className={`${styles.feed_buttonsContainer_button} ${styles.hoverMuroEdify} ${styles.feed_buttonsContainer_button_muroEdify}`}
                        onClick={premiumCheck(handleOpenMainModalTxt)}
                    >
                        <div className={styles.feed_buttonsContainer_button_text_title} style={{ color: "rgb(147 51 234 )" }}>
                            <div className={`${styles.feed_buttonsContainer_button_icon} ${styles.feed_buttonsContainer_button_icon_muroEdify}`}>
                                <Proyectos width={24} height={24} />
                            </div>
                            Muro de Edify
                        </div>
                        <div className={styles.feed_buttonsContainer_button_text}>
                            <span>Comparte novedades, fotos y actualizaciones con la comunidad</span>
                        </div>
                    </div>
                    <div
                        id={CLICK_IDS.OFERTA_DE_TRABAJO_BUTTON_HOME}
                        className={`${styles.feed_buttonsContainer_button} ${styles.hoverOfertaTrabajo} ${styles.feed_buttonsContainer_button_ofertaTrabajo}`}
                        onClick={handleCreateWorkOffer}
                    >
                        <div className={styles.feed_buttonsContainer_button_text_title} style={{ color: "#22af86" }}>
                            <div className={styles.feed_buttonsContainer_button_iconWorkBag}>
                                <HardHat size={24} />
                            </div>
                            Oferta de trabajo
                        </div>
                        <div className={styles.feed_buttonsContainer_button_text}>
                            <span>Encuentra al trabajador ideal para tu equipo</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.header_titleSortContainer}>
                <div className={styles.dropdown}>
                    <span className={styles.header_line}></span>
                    <span style={{ minWidth: "fit-content", paddingLeft: "10px" }}>Ordernar por:</span>
                    <button className={styles.dropdown_button} onClick={() => setShowMenu(!showMenu)}>
                        {getButtonLabel(selectedOption)}
                        {showMenu ? <FontAwesomeIcon icon={faCaretUp} /> : <FontAwesomeIcon icon={faCaretDown} />}
                    </button>
                    {showMenu && (
                        <motion.div
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.2 }}
                            className={styles.dropdown_content}>
                            <button
                                onClick={() => handleOptionClick("recientes")}
                                className={styles.dropdown_content_option}
                            >
                                Recientes
                            </button>
                            <button
                                onClick={() => handleOptionClick("propios")}
                                className={styles.dropdown_content_option}
                            >
                                Propios
                            </button>
                            <button
                                onClick={() => handleOptionClick("recomendados")}
                                className={styles.dropdown_content_option}
                            >
                                Recomendados
                            </button>
                        </motion.div>
                    )}
                </div>
            </div>

            <div className={styles.feedItemContainer}>
                <InfiniteScroll
                    pageStart={0}
                    loadMore={isSorted ? () => { } : fetchItems}
                    hasMore={true || false}
                    sizes={sizes}
                >
                    <ResponsiveMasonry
                        columnsCountBreakPoints={{ 400: 1, 800: 1, 1400: 1 }}
                    >
                        <Masonry gutter="20px">

                            {items.map((item, index) => (
                                <FeedCard
                                    key={`${item.id}-${page}-${index}`}
                                    item={item}
                                    myPosts={myPosts}
                                    onLike={handleLikeFromChild}
                                />
                            ))}
                            {loadingMore && Array.from({ length: 30 }).map((_, index) => (
                                <FeedCardSkeleton key={`skeleton-${index}`} />
                            ))}
                        </Masonry>
                    </ResponsiveMasonry>
                </InfiniteScroll>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.general.userData,
        posteos: state.dashboard.posteos,
        ownPosteos: state.dashboard.ownPosteos,
        recentPost: state.dashboard.recentPost,
        isUserPremium: state.general.isUserPremium,
    };
};

export default connect(mapStateToProps, {
    openSuscriptionModal,
    openFeedTextModal,
    closeMainModal,
    getPosteos,
    getOwnPosteos,
    openWorkOfferModal,
    resetRecentPost
})(Feed);
